export const login = {
  "title": "Admin Panel Login",
  "emailLabel": "Email address",
  "passwordLabel": "Password",
  "signingInButton": "Signing In...",
  "signInButton": "Sign In",
  "pinLoginLink": "Switch to PIN Login",
  "registerLink": "Register New Account"
};
